<template>
  <div>
    <div
      v-if="!loadingProductTree"
      class="product-tree-collapse"
    >
      <b-collapse
        animation="fade"
        v-for="(category, categoryIndex) of productTreeCategories"
        :key="`category-index${categoryIndex}`"
        :open="isOpen === categoryIndex || expandAll() === true || category.hide === true"
        @open="isOpen = categoryIndex"
      >
        <template #trigger="props">
          <p
            v-if="category.hide !== true"
            class="product-tree-collapse-title pt-1 pb-1 mt-1 border-bottom"
            v-bind:class="props.open ? 'title-bg-grey' : ''"
          >
            <b-icon icon="chevron-down" v-bind:style="`transform: rotate(${props.open ? 180 : 0}deg);`" />
            {{ category.name }}
          </p>
        </template>
        <div
          class="columns"
          :class="category.hide !== true ? 'mt-1' : null"
        >
          <div
            class="column"
            v-for="(subCategory, subCategoryIndex) in category.sub_categories"
            :key="`tree-sub-category-${subCategoryIndex}`"
          >
            <div>
              <div
                class="text-center"
                v-bind:style="`color: ${subCategory.text_color}; background-color: ${subCategory.bg_color}`"
              >
                <img
                  v-if="['picture', 'picture_title'].includes(subCategory.display_type)"
                  :src="subCategory.picture_url"
                  alt="category picture"
                  :class="pictureClass(subCategory)"
                >
                <h2
                  v-if="['title', 'picture_title'].includes(subCategory.display_type)"
                  class="is-size-6 has-text-weight-bold"
                  :class="titleClass(subCategory)"
                >
                  {{ subCategory.name }}
                </h2>
              </div>
              <product-tree-product-card
                v-for="(productTree, productTreeIndex) in subCategory.products"
                :key="`tree-sub-category-${productTreeIndex}`"
                :product-tree="productTree"
                :add-to-cart-btn="addToCart()"
              />
            </div>
          </div>
        </div>
      </b-collapse>
    </div>

    <!-- Loading product tree -->
    <div v-if="loadingProductTree">
      <spinner :show-text="false" />
    </div>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { CustomisationMixin } from "@/mixins/CustomisationMixin";
import cug from "@/services/cug";
import VueI18n from "vue-i18n";
import Spinner from "@/components/shared/Spinner";
import ProductTreeProductCard from "@/components/partial/productTree/ProductTreeProductCard";

// Import specific Buefy components
import { Collapse } from 'buefy'
import Vue from "vue";
Vue.use(Collapse);

export default {
  name: "ProductTree",
  mixins: [LocaleMixin, CustomisationMixin],
  components: { ProductTreeProductCard, Spinner },
  props: {
    productTreeId: String,
    expand: {
      type: Boolean,
      default: false
    },
    hideAddToCart: {
      type: Boolean,
      default: false
    },

    // TODO : Delete after widget-options depreciation
    widgetOptions: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      isOpen: 0,
      productTreeCategories: [],
      loadingProductTree: true
    };
  },

  created () {
    this.getProductTree();
  },

  methods: {
    expandAll () {
      if (this.customisation && this.customisation.expand !== undefined) {
        return this.customisation.expand;
      } else {
        return this.expand;
      }
    },

    addToCart () {
      if (this.customisation && this.customisation.addToCartBtn !== undefined) {
        return this.customisation.addToCartBtn;
      } else {
        return !this.hideAddToCart;
      }
    },

    getProductTree () {
      cug
        .productTree(this.productTreeId)
        .then(resp => {
          this.productTreeCategories = resp.data.categories;
        })
        .finally(() => {
          this.loadingProductTree = false;
        });
    },

    pictureClass (subCategory) {
      if (subCategory.display_type === "picture_title") {
        return "mt-2";
      } else if (subCategory.display_type === "picture") {
        return "mt-2 mb-1";
      }
    },

    titleClass (subCategory) {
      if (subCategory.display_type === "picture_title") {
        return "pb-3 pt-2";
      } else if (subCategory.display_type === "title") {
        return "pb-5 pt-5";
      }
    }
  },

  // Translate component
  mounted () {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {},
      fr: {}
    }
  })
};
</script>

<style lang="scss" src="../assets/styles/buefy/base.scss"></style>
<style lang="scss" scoped>
.highlight-category {
  border-style: solid;
  border-width: 1px;
  background-color: #fafafa;
  border-color: #f1f1f1;
  color: #8a8a8a;
}
.product-tree-collapse {
  .product-tree-collapse-title {
    cursor: pointer;
    font-size: 1.35em;
    color: black;
    opacity: 0.75;
    .icon {
      vertical-align: text-bottom;
      transition: 0.3s;
    }
    &:hover {
      opacity: 1;
    }
    &.title-bg-grey {
      background-color: #f7f7f7;
    }
  }
}
</style>
